export default "__VITE_ASSET__Tx9wLbRY__"